import styles from './DelegatedEmailVerificationStatus.module.scss'

export interface DelegatedEmailVerificationStatusProps {
  state?: string
}

export const DelegatedEmailVerificationStatus = ({ state }: DelegatedEmailVerificationStatusProps) => {
  switch (state) {
    case 'live':
      return (
        <div className={`${styles['status-badge']} ${styles['status-badge-live']}`}>
          <i className='bi bi-check-lg' />
          <span className='label-small'>Verified</span>
        </div>
      )
    case 'validating': {
      return (
        <div className={`${styles['status-badge']} ${styles['status-badge-validating']}`}>
          <i className='bi bi-clock' />
          <span className='label-small'>Check your inbox to verify</span>
        </div>
      )
    }
    case 'invalid': {
      return (
        <div className={`${styles['status-badge']} ${styles['status-badge-invalid']}`}>
          <i className='bi bi-exclamation-circle' />
          <span className='label-small'>Linked to another account. Verify again to use it.</span>
        </div>
      )
    }
    default:
      return null
  }
}
